import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.id,
    requestParams: {
      mesVersion: rowInfo.original.messageVersion, // eslint-disable-line
      eventId: rowInfo.original.eventId, // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextWrapColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextWrapColumn('Error message', 'errorMessageArray'),
        new NavigationColumn(new NonZeroNumberColumn('Number of messages', 'numberOfMessages').withWidth(80), getDetailsTabNavigationProps),
      ],
    },
  ];
};
